<template>
  <yxt-drawer
    :title="$t('pc_menu_type_3')"
    :visible="visible"
    @close="handleCancel"
    size="480px"
    direction="rtl">
      <yxt-form ref="refForm" class="form-box" :rules="rules" :model="formData"  is-need-require is-need-tooltip>
        <yxt-form-item :label="$t('pc_l_select_role')" prop="roles">
          <yxt-select
            v-model="formData.roles"
            multiple
            :placeholder="$t('pc_select_placeholder')"
            icon-name="more"
            hidden-option
            collapse-tags
            value-key="id"
            prop-label="fullname"
            @change="formData.auditType = 0"
            @visible-change="dialogVisible=true"
          >
            <template slot='tag' slot-scope='{ data }'>
              <yxtbiz-user-name :name="data.currentLabel" />
            </template>
          </yxt-select>
        </yxt-form-item>

        <yxt-form-item
          class="sel-type-item"
          v-if="formData.roles.length > 1"
          :label="$t('pc_audit_multi')"
        >
          <yxt-radio-group v-model="formData.auditType">
            <yxt-radio :label="0">
              {{$t('pc_audit_or')}}
              <yxt-tooltip
                effect="dark"
                :content="$t('pc_audit_or_tip')"
              >
                <yxt-svg
                  icon-class='question-cirlce-o'
                  class="ml4 color-gray-7"
                  width='16px'
                  height='16px'
                ></yxt-svg>
              </yxt-tooltip>
            </yxt-radio>
            <yxt-radio :label="1">
              {{$t('pc_audit_and')}}
              <yxt-tooltip
                effect="dark"
                :content="$t('pc_audit_and_tip')"
              >
                <yxt-svg
                  icon-class='question-cirlce-o'
                  class="ml4 color-gray-7"
                  width='16px'
                  height='16px'
                ></yxt-svg>
              </yxt-tooltip>
            </yxt-radio>
          </yxt-radio-group>
        </yxt-form-item>

      </yxt-form>
      <div slot="footer">
        <yxt-button plain @click="handleCancel">{{$t('pc_cancel_mini')}}</yxt-button>
        <yxt-button type='primary' @click="handleOk">{{$t('pc_ok_mini')}}</yxt-button>
      </div>
      <yxt-drawer
        :header-border='false'
        :destroy-on-close="true"
        size="960px"
        :visible.sync="dialogVisible"
      >
        <yxtbiz-range-selector
          ref="selector"
          :selected="formData.roles"
          model="array"

          @change="roles = $event"
          :tabs="['persons', 'advance']"
          :function-code='functionCode'
          :data-permission-code='dataPermissionCode'
        >
        </yxtbiz-range-selector>
        <div slot='footer'>
          <yxt-button
            @click="dialogVisible=false"
            plain
          >{{$t('pc_cancel')}}</yxt-button>
          <yxt-button
            type="primary"
            @click="handleRolesOk"
          >{{$t('pc_ok')}}</yxt-button>
        </div>
      </yxt-drawer>

  </yxt-drawer>
</template>
<script>
export default {
  inject: [ 'functionCode', 'dataPermissionCode' ],
  props: {
    default: Object
  },
  data() {
    return {
      visible: true,
      roles: [],
      dialogVisible: false,
      formData: {
        roles: [],
        auditType: 0
      },
      rules: {
        roles: [
          { required: true, message: this.$t('pc_select_placeholder'), trigger: 'blur' } ]
      }
    };
  },
  watch: {
    default: {
      immediate: true,
      handler(v) {
        if (v) {
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          const {...others } = this.formData;
          if (v.appters) {
            this.roles = this.formData.roles = v.appters.map(it => ({
              id: it.userId,
              fullname: it.fullName
            }));
          }
          for (const k in others) {
            if (typeof v[k] !== 'undefined') {
              this.formData[k] = v[k];
            }
          }
        }
      }
    }
  },
  methods: {
    handleVisible(v) {
      this.$emit('update:visible', v);
    },
    handleCancel() {
      this.handleVisible(false);
    },
    handleOk() {
      this.$refs.refForm.validate((isOk) => {
        if (isOk) {
          const { roles, ...others } = this.formData;
          others.appters = roles.map(it => ({
            userId: it.id,
            fullName: it.fullname
          }));
          this.$emit('click:ok', others);
        }
      });
    },
    handleRolesOk() {
      if (this.roles.length > 200 || this.roles.length < 1) {
        this.$message.warning(this.$t('pc_select_max_min', [1, 200]));
        return;
      }
      this.dialogVisible = false;
      this.formData.roles = this.roles;
    }
  }
};
</script>
<style scoped>
.form-box /deep/ .yxt-select {
  width: 328px;
}

.sel-type-item /deep/ .yxt-radio__label {
  display: inline-flex;
  align-items: center;
}
.sel-type-item /deep/ .yxt-form-item__content {
  height: 40px;
  display: flex;
  align-items: center;
}

</style>
